import { useQuery } from '@tanstack/react-query';
import {
  loadCoPilotTraceSummary,
  type CoPilotTraceSummaryResponse,
} from '../../store/coPilotTraceSummaryStore';

const CO_PILOT_TRACE_SUMMARY_QUERY_KEY = 'co-pilot-trace-summary';

export const useCoPilotTraceSummary = ({
  threadId,
  targetId,
  enabled = true,
}: {
  threadId: string;
  targetId?: string;
  enabled?: boolean;
}) => {
  const result = useQuery<CoPilotTraceSummaryResponse>({
    queryKey: [CO_PILOT_TRACE_SUMMARY_QUERY_KEY, targetId ?? null, threadId],
    queryFn: () => loadCoPilotTraceSummary({ threadId, targetId }),
    enabled: enabled && Boolean(threadId),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

  return {
    summary: result.data,
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch,
  };
};
